import { ReactComponent as EmptyTeamsList } from "components/icons/no-candidates.svg"
import EmptyState from "page-components/talent/shared/EmptyState"

export const TeamsListEmptyState = ({ hasError }: { hasError: boolean }) => {
    return (
        <EmptyState
            icon={EmptyTeamsList}
            heading="No Companies Found"
            subheading={
                hasError
                    ? `There was an error retrieving companies for you. Please try again.`
                    : "There are no companies available. Please check back again later."
            }
        />
    )
}
